import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBnebvpUx2xZudCWEn5pH3lpGaSxjANO3U',
  authDomain: 'inkrodriguez-4d795.firebaseapp.com',
  projectId: 'inkrodriguez-4d795',
  storageBucket: 'inkrodriguez-4d795.firebasestorage.app',
  messagingSenderId: '528413042080',
  appId: '1:528413042080:web:95d6b450432387f9b7b0c5',
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, auth, storage, firebaseConfig };